import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, } from '@mui/material';
const MachineModal = ({ open, machine, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        yearModel: undefined,
        model: '',
        vin: '',
        engineNumber: '',
        rego: '',
        notes: '',
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (machine) {
            setFormData({
                name: machine.name,
                description: machine.description || '',
                yearModel: machine.yearModel || undefined,
                model: machine.model || '',
                vin: machine.vin || '',
                engineNumber: machine.engineNumber || '',
                rego: machine.rego || '',
                notes: machine.notes || '',
            });
        }
        else {
            setFormData({
                name: '',
                description: '',
                yearModel: undefined,
                model: '',
                vin: '',
                engineNumber: '',
                rego: '',
                notes: '',
            });
        }
        setErrors({});
    }, [machine, open]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        // Handle yearModel as number
        if (name === 'yearModel') {
            const numValue = value === '' ? undefined : parseInt(value, 10);
            setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: numValue })));
        }
        else {
            setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
        }
        // Clear error for this field
        if (errors[name]) {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { [name]: '' })));
        }
    };
    const validate = () => {
        var _a;
        const newErrors = {};
        if (!((_a = formData.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            newErrors.name = 'Name is required';
        }
        if (formData.yearModel && (formData.yearModel < 1900 || formData.yearModel > new Date().getFullYear() + 1)) {
            newErrors.yearModel = 'Please enter a valid year';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = () => {
        if (validate()) {
            // Clean up the data before sending
            const dataToSend = {
                name: formData.name,
                description: formData.description || undefined,
                yearModel: formData.yearModel || undefined,
                model: formData.model || undefined,
                vin: formData.vin || undefined,
                engineNumber: formData.engineNumber || undefined,
                rego: formData.rego || undefined,
                notes: formData.notes || undefined,
            };
            onSave(dataToSend);
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "md", fullWidth: true, children: [_jsx(DialogTitle, { children: machine ? 'Edit Machine' : 'Add Machine' }), _jsx(DialogContent, { children: _jsxs(Grid, { container: true, spacing: 2, sx: { mt: 1 }, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, label: "Name", name: "name", value: formData.name, onChange: handleChange, error: !!errors.name, helperText: errors.name, required: true }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, label: "Description", name: "description", value: formData.description, onChange: handleChange, multiline: true, rows: 2 }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(TextField, { fullWidth: true, label: "Model", name: "model", value: formData.model, onChange: handleChange }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(TextField, { fullWidth: true, label: "Year Model", name: "yearModel", type: "number", value: formData.yearModel || '', onChange: handleChange, error: !!errors.yearModel, helperText: errors.yearModel, inputProps: { min: 1900, max: new Date().getFullYear() + 1 } }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(TextField, { fullWidth: true, label: "Registration", name: "rego", value: formData.rego, onChange: handleChange }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(TextField, { fullWidth: true, label: "VIN", name: "vin", value: formData.vin, onChange: handleChange }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, label: "Engine Number", name: "engineNumber", value: formData.engineNumber, onChange: handleChange }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, label: "Notes", name: "notes", value: formData.notes, onChange: handleChange, multiline: true, rows: 3 }) })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancel" }), _jsx(Button, { onClick: handleSubmit, variant: "contained", children: machine ? 'Update' : 'Create' })] })] }));
};
export default MachineModal;
